var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBEC0",
    fillRule: "evenodd",
    d: "M6.25 7a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M3.126 18.754a6.875 6.875 0 0 1 13.748 0 .63.63 0 0 1-.364.58A15.6 15.6 0 0 1 10 20.75c-2.322 0-4.527-.507-6.51-1.417a.63.63 0 0 1-.364-.579",
    clipRule: "evenodd"
  })));
};
export default SvgUserIcon;